import HTTP from "../http";

export default {
  createEvent(body) {
    HTTP.RDStation.post("events", body);
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/RDStation.js